import keyMirror from 'keymirror-nested'

export default keyMirror({
  POST_DATA: {
    FETCH: {
      REQUEST: null,
      SUCCEEDED: null,
      FAILED: null,
    },
    CLEAN: {
      ERRORS: null,
      STATE: null,
    },
  },
})
